import RepoTypeIcon from 'components/RepoTypeIcon';
import SummaryCard from 'components/SummaryCard';
import React from 'react';

// SAMPLE DATA
// {
//     "id": 28,
//     "owner_info": {
//         "name": "Naveed Ashraf",
//         "company": "Security Program 360",
//         "email": null,
//         "type": "User"
//     },
//     "user": {
//         "id": 9,
//         "first_name": "naveed",
//         "last_name": "ashraf",
//         "email": "naveed@12tech.com"
//     },
//     "title": "github/naveed-ashraf-pk",
//     "created_at": "2024-02-24T03:58:23.284527Z",
//     "updated_at": "2024-02-24T03:58:23.284548Z",
//     "is_active": true,
//     "host_type": "github",
//     "polymorphic_ctype": 126,
//     "company": 102
// }

const AccountInfoSummary = ({ props, description, mode }) => {
  const data = [
    { key: 'Active', value: props.is_active },
    { key: 'Created At', value: props.created_at },
    {
      key: 'Added By',
      value: `${props.user.first_name} ${props.user.last_name}`,
    },
    props.owner &&
      props.owner.name && { key: 'Owner Name', value: props.owner.name },
    props.owner &&
      props.owner.email && { key: 'Owner Email', value: props.owner.email },
    props.owner &&
      props.owner.company && {
        key: 'Owner Company',
        value: props.owner.company,
      },
    // { key: 'URL', value: 'https://test.url.co/' },
  ];

  return (
    <SummaryCard
      heading={props['title']}
      data={data}
      description={description}
      icon={<RepoTypeIcon repoType={props['host_type']} size={48} />}
      mode={mode}
      //   iconClass="fa-brands fa-github" // Assuming you have corresponding icons in your icon library
    />
  );
};

export default AccountInfoSummary;
